import { useEffect } from 'react'

interface useLoadReportsProps {
  isLoadedReps: string
  reports: Array<any>
  loadedCounterReps: number
  isLoaded: boolean
  setLoadedCounterReps: Function
  setDataLoaded: Function
  setShowOverlay: Function
}

const useLoadReports = (props: useLoadReportsProps) => {

  useEffect(() => {
    if (props.isLoadedReps !== '') {
      props.setLoadedCounterReps((prev) => prev + 1)
    }
  }, [props.isLoadedReps])

  useEffect(() => {
    if (props.isLoaded && props.loadedCounterReps === props.reports.length) {
        props.setDataLoaded(true)
        props.setShowOverlay(false)
    }
  }, [props.isLoaded, props.loadedCounterReps])
}

export default useLoadReports
